import styled from "styled-components";

import { PresentationButtonContainer } from "../../atoms/PresentationButton/styles";
import { PresentationVideoContainer } from "../../atoms/PresentationVideo/styles";

export const AboveTheFolderSectionFallback = styled.div``;

export const AboveTheFolderSectionContainer = styled.section`
  transition: all 0.2s ease-in-out;

  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  gap: 5rem;
  padding-bottom: 3rem;

  @media (min-width: 768px) {
    padding-bottom: 5rem;
  }

  ${PresentationVideoContainer} {
    width: 100%;

    @media (min-width: 768px) {
      width: 80%;
    }

    @media (min-width: 980px) {
      flex: 1 1 40%;
      width: auto;
    }
  }

  @media (min-width: 980px) {
    flex-direction: row;
    gap: 7rem;
  }

  @media (min-width: 1300px) {
    flex-direction: row;
    gap: 10rem;
  }
`;

export const AboveTheFolderTextContent = styled.div`
  transition: all 0.2s ease-in-out;

  display: flex;
  flex-direction: column;
  align-items: center;

  flex: 1 1 40%;
  gap: 1.5rem;

  max-width: 36.25rem;

  @media (min-width: 980px) {
    align-items: start;
  }

  .loader {
    color: ${({ theme }) => theme.colors.textMasterColor} !important;
  }

  ${PresentationButtonContainer} {
    font: 600 1rem/1.5rem "Inter";

    .play-icon * {
      fill: ${({ theme }) => theme.colors.textMasterColor} !important;
    }
  }
`;
